import { render } from "./Contact.vue?vue&type=template&id=f9e7e102&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=f9e7e102&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f9e7e102"

export default script